import api from "api/api"

export const GET_PRODUCT_LOCATIONS_DETAILS = '[PRODUCT_ASSIGNED_LOCATIONS] GET_PRODUCT_LOCATIONS_DETAILS'
export const GET_PRODUCT_LOCATIONS_DETAILS_LOADING = '[PRODUCT_ASSIGNED_LOCATIONS] GET_PRODUCT_LOCATIONS_DETAILS_LOADING'

export function getProductLocationsDetails(productId) {
  return async (dispatch) => {
    dispatch({
      type: GET_PRODUCT_LOCATIONS_DETAILS_LOADING,
      payload: true
    })

    try {
      const response = await api.get(`/product-locations-details/${productId}`)
      dispatch({
        type: GET_PRODUCT_LOCATIONS_DETAILS,
        payload: response.data.data
      })
    } catch (error) {
      console.error(GET_PRODUCT_LOCATIONS_DETAILS, error)
    } finally {
      dispatch({
        type: GET_PRODUCT_LOCATIONS_DETAILS_LOADING,
        payload: false
      })
    }
  }
}
